// ハンバーガーメニュー
$(function(){
    const syncDrawerScrollLock = () => {
        const isDrawerOpen = $('.p-header__nav.js-active').length > 0;
        const sectionHeader = document.querySelector('.section-header');
        const stickyHeader = document.querySelector('sticky-header');

        $('html, body').toggleClass('e8-drawer-open', isDrawerOpen);

        if (sectionHeader) {
            sectionHeader.classList.toggle('menu-open', isDrawerOpen);
        }

        if (stickyHeader && isDrawerOpen) {
            stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
    };

    $('.js-hamburger-btn').on('click', function() {
        $('.js-hamburger').toggleClass('js-active');
        $('#header').toggleClass('js-hamburger-active');
        syncDrawerScrollLock();
        return false;
    });

    $(window).on('resize', function() {
        if (window.innerWidth > 900) {
            $('html, body').removeClass('e8-drawer-open');
        }
    });

    $('.load-fade').addClass('js-active');
});

// スクロール
$(function(){
    $('a[href^="#"]').click(function(){
        if ($(this).closest('localization-form').length) {
            return;
        }
        var adjust = 20,
            speed = 500,
            href= $(this).attr("href"),
            target = $(href == "#" || href == "" ? 'html' : href),
            position = target.offset().top - adjust;
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
    });
});

(function () {
    var fadeScrollTicking = false;

    function onFadeScroll() {
        if (fadeScrollTicking) return;
        fadeScrollTicking = true;
        window.requestAnimationFrame(function () {
            var scrollTop = $(window).scrollTop(),
                deviceHeight = $(window).height(),
                scrollBottom = scrollTop + deviceHeight,
                $footer = $('#footer');

            if ($footer.length && scrollBottom > $footer.offset().top) {
                $('#navigation').removeClass('js-active');
            }

            $('.fade-in-reference').each(function () {
                var $this = $(this),
                    fadeInReference = $this.innerHeight() / 2 + $this.offset().top;

                if (scrollBottom > fadeInReference) {
                    $this.find('.js-fade').addClass('js-active');
                }
            });

            $('.fade-in-reference02').each(function () {
                var $this03 = $(this),
                    fadeInReference02 = $this03.offset().top;

                if (scrollBottom > fadeInReference02) {
                    $this03.find('.js-fade').addClass('js-active');
                }
            });

            fadeScrollTicking = false;
        });
    }

    $(window).on('scroll load', onFadeScroll);
})();
